export default __webpack_public_path__ + "static/halloween-01-mob-d89747d8c35506c5731496a613ed6cab.jpg";